<template>
    <div>
        <v-card outlined v-show="showAlert" class="v-card-border-none">
            <v-card-title class="pt-2 pb-2 v-card-custom-title">
                <div class="text-left v-card-custom-title-left">
                    <template v-if="!VUETIFY_BREAKPOINT.mobile">
                        <span style="white-space: nowrap"
                            >{{ $t("alert.title.HighVolumeUSD")
                            }}<v-tooltip right v-if="configWarning">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        color="red"
                                        small
                                        style="margin-left: 2px"
                                        >mdi-information-outline</v-icon
                                    >
                                </template>
                                <span>{{
                                    $t("alert.noConfigFound.HighVolumeUSD")
                                }}</span>
                            </v-tooltip></span
                        >
                    </template>
                </div>
                <div class="text-right v-card-custom-title-right">
                    <v-btn
                        icon
                        x-small
                        :loading="loading"
                        color="primary"
                        v-on:click="refreshData()"
                        style="margin-right: 2px"
                        class="alertRefresh"
                        ><v-icon>mdi-refresh</v-icon>
                    </v-btn>
                    <v-btn
                        icon
                        x-small
                        color="#d35400"
                        v-on:click="toggleDateFilter()"
                        style="margin-right: 2px"
                        class="alertCalender"
                        ><v-icon>mdi-calendar</v-icon>
                    </v-btn>
                    <template v-if="!VUETIFY_BREAKPOINT.mobile">
                        <download-excel
                            :data="filteredAlertData"
                            :fields="csvHeader"
                            style="display: inline"
                            type="csv"
                            :name="
                                $t('alert.exportName.HighVolumeUSD') + '.csv'
                            "
                            :escapeCsv="false"
                        >
                            <v-btn
                                icon
                                x-small
                                :disabled="filteredAlertData.length === 0"
                                color="green"
                                style="margin-right: 2px"
                                class="alertDownload"
                                ><v-icon>mdi-microsoft-excel</v-icon>
                            </v-btn>
                        </download-excel>
                        <v-btn
                            icon
                            x-small
                            color="blue-grey darken-1"
                            v-on:click="
                                getConfigForAlertAction('High Volume USD')
                            "
                            style="margin-right: 2px"
                            v-if="showConfig"
                            class="alertConfig"
                            ><v-icon>mdi-cog</v-icon>
                        </v-btn>
                        {{ " " }}
                        <v-icon
                            small
                            style="color: grey"
                            @click="$emit('onRemove')"
                            class="alertClose"
                            >mdi-close-thick</v-icon
                        >
                    </template>
                </div>
            </v-card-title>

            <v-data-table
                dense
                item-key="name"
                :customSort="(item) => item"
                :items="filteredAlertData"
                :headers="ibDeterminedHeader"
                class="elevation-0 alert-datatable"
                :items-per-page.sync="offset"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :height="height - 120"
                fixed-header
                :header-props="{ sortIcon: null }"
                :page.sync="currentPage"
                :server-items-length="alertDataAmount"
                :mobile-breakpoint="0"
                :footer-props="{
                    pagination: {
                        page: currentPage,
                        itemsPerPage: offset,
                        pageStart: (currentPage - 1) * offset,
                        pageStop: currentPage * offset,
                        pageCount: Math.ceil(alertDataAmount / offset),
                        itemsLength: alertDataAmount,
                    },
                    'items-per-page-text': '',
                    'items-per-page-options': [30, 50, 100, 300, 500, 1000],
                }"
            >
                <template v-slot:item="{ item }">
                    <tr
                        @mouseover="updateRow(item)"
                        v-on:click="rowClicked(item)"
                    >
                        <td column="IB" align="left" v-if="isIBRequired">
                            {{ item.partner_id }}
                        </td>
                        <td
                            column="Back Office"
                            align="left"
                            v-if="isIBRequired"
                        >
                            {{ item.back_office_id }}
                        </td>
                        <td column="Customer" align="left" v-if="isIBRequired">
                            {{ item.account_id }}
                        </td>
                        <td column="login">
                            <a
                                v-on:click.stop="handleLoginClick(item)"
                                v-if="showHomeLoginDetailSummary"
                                style="display: inline-block; height: 21px"
                                >{{ item.server_name + ":" + item.login }}</a
                            >

                            <div v-else>
                                {{ item.server_name + ":" + item.login }}
                            </div>
                            <v-icon v-show="item.new == true"
                                >mdi-new-box</v-icon
                            >
                        </td>
                        <td
                            column="name"
                            align="left"
                            class="truncate-name-cell"
                            v-if="
                                selectedProfile.settings['highVolumeUSD'].name
                                    .showing
                            "
                        >
                            {{ decodeMaybeHexOrGarbled(item.name) }}
                        </td>
                        <td
                            column="books"
                            v-if="
                                selectedProfile.settings['highVolumeUSD'].books
                                    .showing
                            "
                        >
                            {{ item.books }}
                        </td>
                        <td
                            column="ccy"
                            v-if="
                                selectedProfile.settings['highVolumeUSD'].ccy
                                    .showing
                            "
                        >
                            {{ item.ccy }}
                        </td>
                        <td
                            column="today_open_volume_usd"
                            align="right"
                            v-if="
                                selectedProfile.settings['highVolumeUSD']
                                    .today_open_volume_usd.showing
                            "
                        >
                            {{
                                numberWithCommas(
                                    item.today_open_volume_usd.toFixed(2)
                                )
                            }}
                        </td>
                        <td
                            column="most_today_opened_volume_usd_symbol"
                            v-if="
                                selectedProfile.settings['highVolumeUSD']
                                    .most_today_opened_volume_usd_symbol.showing
                            "
                        >
                            {{ item.most_today_opened_volume_usd_symbol }}
                        </td>
                        <td
                            column="today_open_trades_profit"
                            align="right"
                            v-if="
                                selectedProfile.settings['highVolumeUSD']
                                    .today_open_trades_profit.showing
                            "
                        >
                            {{
                                numberWithCommas(
                                    item.today_open_trades_profit.toFixed(2)
                                )
                            }}
                        </td>
                        <td
                            column="trigger_time"
                            v-if="
                                selectedProfile.settings['highVolumeUSD']
                                    .trigger_time.showing
                            "
                        >
                            {{ item.trigger_time }}
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>

        <v-dialog v-model="visible" width="400" :hide-overlay="false">
            <v-card>
                <v-card-title class="text-h5">{{
                    $t("alert.filterDates")
                }}</v-card-title>
                <v-card-text>{{ $t("alert.filterDatesMessage") }}</v-card-text>
                <v-container>
                    <v-row>
                        <v-col
                            lg="12"
                            md="12"
                            xs="12"
                            cols="12"
                            style="text-align: center"
                        >
                            <v-date-picker v-model="recordDate"></v-date-picker>
                        </v-col>
                    </v-row>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text v-on:click="refreshData()"
                        >Ok</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <LoginSummaryDialog
            v-if="dialog"
            :fullLogin="fullLoginValue"
            :login="loginValue"
            :server="serverValue"
            :symbol="symbolValue"
        />
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import LoginSummaryDialog from "@components/login-summary/ComponentLoginSummaryDialog";
import { helper } from "@components/mixins/helper";
import common from "@assets/js/common";
import deepClone from "deep-clone";
import { permission } from "@components/mixins/permission";
import { getConfig } from "@services/alert/config";
import { redirectToRH } from "@utils/util";

export default {
    mixins: [helper, permission],
    components: { LoginSummaryDialog },
    props: {
        height: 0,
        showing: false,
        showConfig: false,
    },
    data() {
        return {
            timeout: null,
            visible: false,
            showAlert: true,
            showMonitor: true,
            showHomeLoginDetailSummary: false,
            dialog: false,
            sortBy: undefined,
            sortDesc: undefined,
            offset: 30,
            currentPage: 1,
            recordDate: common.getMT4TimeString().split(" ")[0],
            alertInterval: null,
            fullLoginValue: null,
            loginValue: null,
            serverValue: null,
            symbolValue: null,
            configWarning: false,
            isIBRequired: false,
        };
    },
    computed: {
        ...mapState("HighVolumeUSD", [
            "alertHeader",
            "alertData",
            "loading",
            "csvHeader",
            "alertDataAmount",
        ]),
        ...mapState("SettingsServer", ["serverData"]),
        ...mapState("Alert", [
            "selectedProfile",
            "selectedPeriod",
            "books",
            "extraIBHeaders",
        ]),
        filteredAlertData() {
            if (!!this.selectedProfile.unselectedBooks) {
                if (this.selectedProfile.unselectedBooks.length === 0) {
                    return this.alertData;
                } else {
                    let filtered = [];
                    this.alertData.map((data) => {
                        if (
                            !(
                                data.books.split(",").length == 1 &&
                                this.selectedProfile.unselectedBooks.includes(
                                    data.books
                                )
                            )
                        ) {
                            filtered.push(data);
                        }
                    });
                    return filtered;
                }
            }
            return this.alertData;
        },
        ibDeterminedHeader() {
            if (this.isIBRequired) {
                return [...this.extraIBHeaders, ...this.alertHeader];
            } else {
                return this.alertHeader;
            }
        },
    },
    watch: {
        selectedProfile(nv) {
            const settings = nv.settings["highVolumeUSD"];
            const columnName = Object.keys(settings);
            let newHeader = deepClone(this.alertHeader);
            newHeader.map((item) => {
                if (columnName.includes(item.value)) {
                    item.align = settings[item.value].showing
                        ? [
                              "today_open_volume_usd",
                              "today_open_trades_profit",
                          ].includes(item.value)
                            ? "right"
                            : "left"
                        : " d-none";
                }
            });
            this.UPDATE_ALERT_HEADER(newHeader);
        },
        showing(nv) {
            if (nv) {
                getConfig("high-volume-usd").then(({ data }) => {
                    if (data.length === 0) {
                        this.configWarning = true;
                    }
                });
                this.getAlertData();

                if (this.selectedPeriod > 1) {
                    this.alertInterval = setInterval(() => {
                        this.getAlertData();
                    }, this.selectedPeriod * 1000);
                }
            } else {
                clearInterval(this.alertInterval);
            }
        },
        selectedPeriod(nv) {
            if (this.showing) {
                clearInterval(this.alertInterval);
                if (nv !== 0) {
                    this.alertInterval = setInterval(() => {
                        this.getAlertData();
                    }, nv * 1000);
                }
            }
        },
        sortBy() {
            this.getAlertData();
        },
        sortDesc() {
            this.getAlertData();
        },
        offset() {
            this.getAlertData();
        },
        currentPage() {
            this.getAlertData();
        },
    },
    methods: {
        ...mapActions("HighVolumeUSD", ["getDataHighVolumeUSDAction"]),
        ...mapMutations("HighVolumeUSD", [
            "UPDATE_ALERT_HEADER",
            "UPDATE_ALERT_DATA",
            "UPDATE_SELECTED_DATE",
        ]),
        ...mapActions("Config", ["getConfigForAlertAction"]),
        toggleDateFilter() {
            this.visible = true;
        },
        refreshData() {
            this.visible = false;
            this.getAlertData();
        },
        getAlertData() {
            this.timeout && clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.UPDATE_SELECTED_DATE(this.recordDate);
                const selectedBooks = this.books.filter(
                    (element) =>
                        !this.selectedProfile.unselectedBooks.includes(element)
                );

                let params = {
                    start_time: this.recordDate + " 00:00:00",
                    end_time: this.recordDate + " 23:59:59",
                    offset: this.offset,
                    page: this.currentPage,
                    sort_by:
                        typeof this.sortBy === "object"
                            ? this.sortBy[0]
                            : this.sortBy,
                    sortDesc:
                        typeof this.sortDesc === "object"
                            ? this.sortDesc[0]
                            : this.sortDesc,
                    selected_book: selectedBooks.join(","),
                    ib_required: this.isIBRequired,
                };
                this.getDataHighVolumeUSDAction(params);
            }, 100);
        },
        changeTab(loadModules) {
            this.showAlert = false;
            this.showMonitor = false;
            if (loadModules == 1) this.showMonitor = true;
            if (loadModules == 2) this.showAlert = true;
        },
        removePrefix(name) {
            return name.split(":")[1];
        },
        rowClicked(item) {
            const broker = this.serverData.find(
                (serverInfo) => serverInfo.server_name === item.server_name
            )?.broker_name;
            if (!!broker) {
                this.fullLoginValue =
                    broker + ":" + item.server_name + ":" + item.login;
                this.loginValue = item.login.toString();
                this.serverValue = item.server_name;
                this.symbolValue =
                    item.most_today_opened_volume_usd_symbol.split(".")[0];
                this.dialog = false;
                this.$nextTick(() => {
                    this.dialog = true;
                });
            }
        },
        handleLoginClick(item) {
            const serverId = item.server_id;
            const login = item.login;
            const url = `/tag-centre/account-analysis/${serverId}-${login}`;
            redirectToRH(url);
        },
        updateRow(row) {
            if (row.new) {
                const index = this.alertData.indexOf(row);
                this.alertData[index].new = false;
                this.UPDATE_ALERT_DATA(this.alertData);
            }
        },
    },
    created() {
        const userFunction = this.getFunction("book");
        const alertChild = JSON.parse(localStorage.getItem("permission"))
            .frontPermission.alert.child;

        if (userFunction.includes("homeLoginDetailSummary")) {
            this.showHomeLoginDetailSummary = true;
        }
        if (alertChild.includes("ibRelatedFieldsAlert")) {
            this.isIBRequired = true;
        }
    },
    mounted() {
        if (!!this.VUETIFY_BREAKPOINT.mobile) {
            this.getAlertData();
        }
    },
    destroyed() {
        clearInterval(this.alertInterval);
    },
};
</script>
